module.exports = __webpack_public_path__ + "img/ru-store.180ce28.svg";